export default (props, vars) =>
  props?.['variant'] === 'v1' || !props?.['variant'];
